import { Modal } from "flowbite-react";
import ComboBoxFormik from "../../../../common/components/form/ComboBoxFormik";
import { FormikProvider, useFormik } from "formik";
import ButtonWithLoader from "../../../../common/components/ui/loading/ButtonLoading";
import { FaCheckCircle } from "react-icons/fa";
import { useEffect, useMemo, useState } from "react";
import { IMaintenance } from "../../../../types/maintenance.type";
import { useToastContext } from "../../../../common/components/ui/toast/toast.context";
import { editWaitingTicketAndMechanic } from "../../../../common/services/maintenance.api";
import InputFormik from "../../../../common/components/form/InputFormik";
import { getMechanicOptions } from "../../../../common/helpers/mechanic";
import { useCompanyStore } from "../../../../common/states/store/Company";

type Props = {
  maintenance: { _id: string; licensePlate: string };
  onClose: () => void;
  data: IMaintenance;
};

export default function ModalEditTicketOrMechanic(props: Props) {
  const { notifySuccess, notifyError } = useToastContext();
  const [isConverted, setIsConverted] = useState(false);
  const [submitResult, setSubmitResult] = useState<string | null>(null);
  const { filterMode, selectedCompanies } = useCompanyStore();

  const singleSelectedCompany = useMemo(() => {
    if (filterMode === "cities" && selectedCompanies.length === 1) {
      return selectedCompanies[0];
    }
    return null;
  }, [filterMode, selectedCompanies]);
  const formik = useFormik({
    initialValues: {
      maintenanceId: props.maintenance._id,
      licensePlate: props.maintenance.licensePlate,
      mechanic: props.data.mechanic,
      waitingTicket: props.data.waitingTicket,
    },
    onSubmit: async (data) => {
      const activationData = {
        maintenanceId: data.maintenanceId,
        mechanic: data.mechanic,
        waitingTicket: data.waitingTicket,
      };
      const result = await editWaitingTicketAndMechanic(activationData);
      if (!result.ok) {
        notifyError(result.message as string);
        setSubmitResult("error");
        return;
      }
      notifySuccess("Alteração feita com sucesso!");
      setSubmitResult("success");
    },
  });
  const badgeColor = useMemo(
    () => (submitResult == "success" ? "text-greenPrimary" : "text-redPrimary"),
    [submitResult]
  );

  useEffect(() => {
    setIsConverted(submitResult === "success");
  }, [submitResult]);

  const mechanicOptions = useMemo(() => {
    if (singleSelectedCompany) {
      return getMechanicOptions(singleSelectedCompany.companyName);
    }
    return [];
  }, [singleSelectedCompany]);
  return (
    <Modal
      className="relative dark:text-black "
      show={true}
      onClose={() => props.onClose()}
    >
      <form onSubmit={formik.handleSubmit}>
        <FormikProvider value={formik}>
          <Modal.Header className="dark:text-black">
            <h2 className="dark:text-black">
              Iniciar manutenção da moto: {props.maintenance.licensePlate}
            </h2>
          </Modal.Header>
          <Modal.Body
            className="w-full flex flex-wrap items-center justify-center border-gray"
            style={{
              minHeight: "calc(100vh - 300px)",
              height: "calc(100vh - 300px)",
            }}
          >
            <section className="grid grid-cols-1 my-4">
              <div>
                <InputFormik
                  label="Número da senha:"
                  name="waitingTicket"
                  type="number"
                  className="w-full"
                />
                <ComboBoxFormik
                  label="Selecione o mecânico responsável pela manutenção:"
                  name={"mechanic"}
                  options={mechanicOptions}
                  className="w-full"
                />
              </div>
            </section>
            <div className="flex flex-col items-center justify-center text-center">
              <div className="pb-[24px]">
                <h2 className="font-semibold ">
                  Clique aqui para salvar as alterações:
                </h2>
              </div>
              <div className="grid-div2">
                <ButtonWithLoader
                  isLoading={formik.isSubmitting}
                  disabled={isConverted}
                  onSave={() => setIsConverted(true)}
                >
                  Salvar
                </ButtonWithLoader>
                <FaCheckCircle size={24} className={`${badgeColor}`} />
              </div>
            </div>
          </Modal.Body>
        </FormikProvider>
      </form>
    </Modal>
  );
}
